import { Box, Card, CardContent, Link, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { mainListItems } from './navigationData/menuItems.jsx';

// Preview of the left nav rendered alongside the welcome card. Items are
// faded and non-interactive — the goal is to show the user what Athena
// will look like once they have a role, not to expose any navigation.
const NavPreview = () => (
    <Box
        sx={{
            width: 172,
            flexShrink: 0,
            height: '100%',
            pt: 2,
            opacity: 0.4,
            pointerEvents: 'none',
            userSelect: 'none',
            borderRight: (theme) => `1px solid ${theme.palette.divider}`,
        }}
        aria-hidden="true"
    >
        <List dense>
            {mainListItems.map((item) => (
                <ListItem key={item.id} sx={{ px: 2 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                    <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{ variant: 'body2' }}
                    />
                </ListItem>
            ))}
        </List>
    </Box>
);

const NoRolesWelcome = () => {
    const userName = useSelector((state) => state.user.profile?.userName);
    // Strip parenthetical suffixes like "(local)" or "(tyto)" that the JWT
    // sometimes appends in dev/test envs so the greeting reads cleanly.
    const displayName = userName?.replace(/\s*\([^)]*\)\s*/g, '').trim();
    const greeting = displayName
        ? `Welcome to Athena, ${displayName}.`
        : 'Welcome to Athena.';

    return (
        <Box sx={{ display: 'flex', flexGrow: 1, height: '100%', overflow: 'hidden' }}>
            <NavPreview />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexGrow: 1,
                    p: 4,
                }}
            >
                <Card sx={{ maxWidth: 720, textAlign: 'center', p: 4 }}>
                    <CardContent>
                        <AutoAwesomeOutlined sx={{ fontSize: 48, color: '#1F4D83', mb: 2 }} />
                        <Typography variant="h4" sx={{ mb: 4 }}>
                            {greeting}
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
                            No role has been assigned to your account yet. Contact
                            your IMCS Program Administrator,{' '}
                            <Link
                                href="mailto:jason.luithle@gotyto.com"
                                underline="hover"
                                sx={{ color: '#1F4D83', fontWeight: 600 }}
                            >
                                Jason Luithle
                            </Link>
                            , to request access.
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Once your role is assigned, refresh or sign in again to
                            continue.
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default NoRolesWelcome;
